// extracted by mini-css-extract-plugin
export default {"loading":"Index_loading__-3WdH","loading_icon":"Index_loading_icon__7+384","t-spin":"Index_t-spin__ogMD6"};